// import axios from "axios";
import { URL } from "../config";

const COMMON_LOCAL_STORAGE_KEY = "sistema_session";
let AUTH_TOKEN = "";

// const instance = axios.create({
//   baseURL: URL,
//   timeout: 1000,
//   headers: { Accept: "application/json", "Content-Type": "application/json" },
// });

// instance.interceptors.request.use(
//   function (config) {
//     let session = localStorage.getItem(COMMON_LOCAL_STORAGE_KEY);
//     if (session) {
//       session = JSON.parse(session);
//       if (session.token !== "") {
//         config.headers["Authorization"] = `Bearer ${session.token}`;
//       }
//       return config;
//     }
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );

const getToken = () => {
  let session = localStorage.getItem(COMMON_LOCAL_STORAGE_KEY);
  if (session) {
    session = JSON.parse(session);
    if (session.token !== "") {
      AUTH_TOKEN = `Bearer ${session.token}`;
    }
    return AUTH_TOKEN;
  }
};

// const instanceOff = axios.create({
//   baseURL: URL,
//   timeout: 1000,
// });

const setToken = (token) => {
  AUTH_TOKEN = `Bearer ${token}`;
  // instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

const getUnauthenticated = async (uri) => {
  const response = await fetch(`${URL}${uri}`);
  return await response.json();
};

const postUnauthenticated = async (uri, data) => {
  let myHeaders = new Headers({
    "Content-Type": "application/json",
  });

  const response = await fetch(`${URL}${uri}`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(data),
  });
  return await response.json();
};

const get = async (uri) => {
  getToken();
  let myHeaders = new Headers({
    Authentication: AUTH_TOKEN,
  });
  const response = await fetch(`${URL}${uri}`, {
    headers: myHeaders,
  });
  return await response.json();
};

const post = async (uri, data) => {
  getToken();

  let myHeaders = new Headers({
    "Content-Type": "application/json",
    Authentication: AUTH_TOKEN,
  });
  const response = await fetch(`${URL}${uri}`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(data),
  });
  return await response.json();
};

const postMultipart = async (uri, data) => {
  getToken();

  let myHeaders = new Headers({
    // "Content-Type": "multipart/form-data",
    Authentication: AUTH_TOKEN,
  });
  const response = await fetch(`${URL}${uri}`, {
    method: "POST",
    headers: myHeaders,
    body: data,
  });
  return await response.json();
};

const put = async (uri, data) => {
  getToken();

  let myHeaders = new Headers({
    "Content-Type": "application/json",
    Authentication: AUTH_TOKEN,
  });
  const response = await fetch(`${URL}${uri}`, {
    method: "PUT",
    headers: myHeaders,
    body: JSON.stringify(data),
  });
  return await response.json();
};

const destroy = async (uri) => {
  getToken();

  let myHeaders = new Headers({
    Authentication: AUTH_TOKEN,
  });

  const response = await fetch(`${URL}${uri}`, {
    method: "DELETE",
    headers: myHeaders,
  });
  return await response.json();
};

export {
  getUnauthenticated,
  postUnauthenticated,
  setToken,
  get,
  post,
  put,
  destroy,
  postMultipart,
  COMMON_LOCAL_STORAGE_KEY,
};
